export default {
  getShipperByID: state => id => state.shippers.find(el => el.id === id),
};
